import './ApplyMethodPicker.scss';
import { SITE_APPLY_METHOD, joinApplyhow, splitApplyhow } from './applyMethods';

interface ApplyMethodPickerProps {
  value: string;
  onChange: (value: string) => void;
  options: string[];
  /** 사이트 지원 게시판(국내·해외 사역지) — 사역자모아 지원이 항상 열려 있다 */
  siteApply: boolean;
  /** 담당자 e-메일 입력 여부 — 'e-메일'을 골랐는데 비어 있으면 안내 */
  hasEmail: boolean;
}

/**
 * 공고 등록 · 지원방법 (application-structure-final.md 2장 — 접수 방법은 교회가 고른다)
 * 트랙 A 사역자모아 지원: 지원서가 사이트에 접수·기록되고, 담당자 이메일로는 첨부 없는 새 지원자 알림만 간다.
 * 트랙 B e-메일: 담당자 이메일이 공고에 공개되고, 사역자가 자기 메일로 직접 보낸다 (사이트 기록 없음).
 */
export default function ApplyMethodPicker({ value, onChange, options, siteApply, hasEmail }: ApplyMethodPickerProps) {
  const current = splitApplyhow(value).filter((v) => v !== SITE_APPLY_METHOD);
  const toggle = (item: string) => {
    const next = current.includes(item) ? current.filter((v) => v !== item) : [...current, item];
    onChange(joinApplyhow(next, siteApply));
  };
  const emailPicked = current.includes('e-메일');

  return (
    <>
      <div className='checkTextRow'>
        {siteApply && (
          <div className='checkTextBox' title='국내·해외 사역지 공고는 사역자모아 지원이 항상 열려 있습니다'>
            <input className="checkbox" type="checkbox" checked readOnly disabled />
            <span className="checkmark" />
            <div className='imgtextBox'>
              <p className='selected'>{SITE_APPLY_METHOD}</p>
            </div>
          </div>
        )}
        {options.map((item) => (
          <div key={item} className='checkTextBox' onClick={() => toggle(item)}>
            <input className="checkbox" type="checkbox" checked={current.includes(item)} readOnly />
            <span className="checkmark" />
            <div className='imgtextBox'>
              <p className={current.includes(item) ? 'selected' : ''}>{item}</p>
            </div>
          </div>
        ))}
      </div>
      <div className='apply-method-note'>
        {siteApply && (
          <p>
            <b>사역자모아 지원</b>은 항상 열려 있습니다. 지원서는 마이페이지 &gt; 지원자 관리에 모이고,
            담당자 이메일로는 이력서 없이 새 지원자 알림만 갑니다.
          </p>
        )}
        {emailPicked && (
          <p>
            <b>e-메일</b>을 고르면 담당자 이메일이 공고에 공개되어 사역자가 자기 메일로 직접 보냅니다.
            이렇게 받은 지원은 사역자모아에 기록되지 않아 지원자 관리에서 볼 수 없습니다.
          </p>
        )}
        {emailPicked && !hasEmail && <p className='warn'>아래 담당자 e-메일을 입력해 주세요.</p>}
      </div>
    </>
  );
}
